<div class="form-button" [ngSwitch]="getUIAppearance()">
  <button
    *ngSwitchCase="'flat'"
    mat-flat-button
    [attr.data-test]="property.Key"
    color="primary"
    (click)="onClick()"
    [matTooltip]="propertyType | tooltipTextId | translate"
    [matTooltipPosition]="'above'"
    [disabled]="!property.Rules.EnableIf"
  >
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
  <button
    *ngSwitchCase="'stroked'"
    mat-stroked-button
    [attr.data-test]="property.Key"
    color="primary"
    (click)="onClick()"
    [matTooltip]="propertyType | tooltipTextId | translate"
    [matTooltipPosition]="'above'"
    [disabled]="!property.Rules.EnableIf"
  >
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
  <button
    *ngSwitchDefault
    mat-flat-button
    [attr.data-test]="property.Key"
    color="primary"
    (click)="onClick()"
    [matTooltip]="propertyType | tooltipTextId | translate"
    [matTooltipPosition]="'above'"
    [disabled]="!property.Rules.EnableIf"
  >
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
</div>

<ng-template #content>{{ propertyType.NameId ? (propertyType.NameId | translate) : property.Key }}</ng-template>
